<template>
  <div>

    <v-alert-dialog ref="alert"></v-alert-dialog>

    <!-- Dialog Crear/Editar -->
    <v-dialog max-width="65%" v-model="dialogAddEdit" persistent>
      <v-card>
        <v-card-title>
          {{ editedItem.id_resguardo_subtipo === null ? "Crear" : "Editar" }}
          Subtipo de {{ tipoNombre }}
        </v-card-title>

        <v-card-text>
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="editedItem.nombre"
                label="Nombre"
                outlined
                dense
                hide-details
              />
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn text color="green" @click="closeDialogAddEdit">Cancelar</v-btn>
          <v-btn text color="red" :loading="loadingSave" @click="saveDialogAddEdit">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog eliminar -->
    <v-dialog max-width="65%" v-model="dialogDelete" persistent>
      <v-card>
        <v-card-title>
          Eliminar Subtipo
        </v-card-title>

        <v-card-text>
          ¿Está seguro de eliminar el subtipo
          "<b>{{ editedItem.nombre }}</b>"?
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn text color="green" @click="closeDialogDelete">Cancelar</v-btn>
          <v-btn text color="red" :loading="loadingDelete" @click="saveDialogDelete">Eliminar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Botón crear -->
    <v-row>
      <v-col cols="12">
        <v-btn color="primary" @click="openDialogAddEdit(null)">
          Crear Subtipo
        </v-btn>
      </v-col>
    </v-row>

    <!-- Tabla -->
    <v-row>
      <v-col cols="12">
        <v-data-table
          :items="items"
          :headers="headers"
          :loading="loading"
        >
          <template v-slot:[`item.actions`]="{ item }">
            <v-icon small class="mr-2" @click="openDialogAddEdit(item)">mdi-pencil</v-icon>
            <v-icon small class="mr-2" @click="openDialogDelete(item)">mdi-delete</v-icon>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import axios from "axios";
import VAlertDialog from "@/components/VAlertDialog.vue";

export default {
  components: { VAlertDialog },

  props: {
    idResguardoTipo: { type: String, required: true },
    tipoNombre: { type: String, default: "Resguardo" }
  },

  data: () => ({
    loading: false,
    loadingSave: false,
    loadingDelete: false,

    items: [],
    headers: [
      {
        text: "Nombre",
        value: "nombre",
        align: "center",
        width: "80%"
      },
      {
        text: "Acciones",
        value: "actions",
        align: "center",
        width: "20%"
      }
    ],

    dialogAddEdit: false,
    dialogDelete: false,

    editedItem: {
      id_resguardo_subtipo: null,
      nombre: "",
      id_resguardo_tipo: null
    },

    defaultEditedItem: {
      id_resguardo_subtipo: null,
      nombre: "",
      id_resguardo_tipo: null
    }
  }),

  mounted() {
    this.getItems();
  },

  methods: {
    // ==============================
    // LISTAR
    // ==============================
    getItems() {
      this.loading = true;
      axios
        .get(`/RACatalogos/ListarResguardoSubtipo/${this.idResguardoTipo}`)
        .then((res) => {
          this.items = res.data;
        })
        .catch((err) => console.log(err))
        .finally(() => (this.loading = false));
    },

    // ==============================
    // DIALOG ADD/EDIT
    // ==============================
    openDialogAddEdit(editItem = null) {
      if (editItem !== null)
        this.editedItem = Object.assign({}, editItem);
      else
        this.editedItem = {
          id_resguardo_subtipo: null,
          nombre: "",
          id_resguardo_tipo: this.idResguardoTipo
        };

      this.dialogAddEdit = true;
    },

    closeDialogAddEdit() {
      this.editedItem = Object.assign({}, this.defaultEditedItem);
      this.dialogAddEdit = false;
    },

    saveDialogAddEdit() {
      if (!this.editedItem.nombre || this.editedItem.nombre.length === 0) {
        this.$refs.alert.setMessage("", "Debe ingresar un nombre válido.");
        this.$refs.alert.open();
        return;
      }

      if (this.editedItem.nombre.length > 512) {
        this.$refs.alert.setMessage("", "El nombre no puede exceder 512 caracteres.");
        this.$refs.alert.open();
        return;
      }

      this.loadingSave = true;

      axios({
        method: this.editedItem.id_resguardo_subtipo === null ? "POST" : "PUT",
        url:
          this.editedItem.id_resguardo_subtipo === null
            ? "/RACatalogos/CrearResguardoSubtipo"
            : `/RACatalogos/EditarResguardoSubtipo/${this.editedItem.id_resguardo_subtipo}`,
        data: {
          nombre: this.editedItem.nombre,
          id_resguardo_tipo: this.idResguardoTipo
        }
      })
        .then(() => {
          this.getItems();
          this.closeDialogAddEdit();
        })
        .catch((err) => {
          if (err.response && err.response.status === 409) {
            this.$refs.alert.setMessage("", "Ya existe un Subtipo con este nombre.");
            this.$refs.alert.open();
          }
        })
        .finally(() => (this.loadingSave = false));
    },

    // ==============================
    // DELETE
    // ==============================
    openDialogDelete(item) {
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },

    closeDialogDelete() {
      this.editedItem = Object.assign({}, this.defaultEditedItem);
      this.dialogDelete = false;
    },

    saveDialogDelete() {
      this.loadingDelete = true;
      axios
        .delete(
          `/RACatalogos/EliminarResguardoSubtipo/${this.editedItem.id_resguardo_subtipo}`
        )
        .then(() => {
          this.closeDialogDelete();
          this.getItems();
        })
        .catch((err) => console.log(err))
        .finally(() => (this.loadingDelete = false));
    }
  }
};
</script>
